import { useMemo } from 'react';
import { useCollaborators } from './useCollaborators';

export function useMyCollaborator() {
  const collaborators = useCollaborators();
  return useMemo(() => {
    return collaborators.find((c) => c.me);
  }, [collaborators]);
}
